import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {SharedComponentsModule} from '../../bonding_shared/components/shared-components.module';
import {ClientCompanyDetailsComponent} from './components/client-company-details.component';
import {CompanySharedModule} from '../company/components/shared/company-shared.module';
import {ClientCompanyAccessGuard} from '../company/_guards/client-company-access.guard';

@NgModule({
  imports: [RouterModule, BrowserModule, SharedComponentsModule, FormsModule, ReactiveFormsModule, CompanySharedModule],
  exports: [],
  declarations: [ClientCompanyDetailsComponent],
  providers: [ClientCompanyAccessGuard],
})
export class ClientCompanyModule {}
